import { Head, Link } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { route } from '../../utils/route';

const XCircleIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <line x1="15" y1="9" x2="9" y2="15" />
    <line x1="9" y1="9" x2="15" y2="15" />
  </svg>
);

export default function CancelOperation() {
  return (
    <MainLayout>
      <Head title="Operación cancelada | Abasto Virtual">
        <meta name="robots" content="noindex" />
      </Head>

      <div className="flex min-h-[60vh] items-center justify-center px-4 py-12">
        <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-lg">
          <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
            <XCircleIcon className="h-8 w-8 text-red-500" />
          </div>

          <h1 className="mb-3 text-xl font-bold text-gray-900">
            Operación cancelada
          </h1>

          <p className="mb-6 text-gray-600">
            No pudimos realizar el cobro de tu pedido, podés reintentarlo haciendo click en "Completar Pago" en Pedidos.
          </p>

          <Link
            href={route('orders.index')}
            className="inline-block rounded-xl bg-green-500 px-6 py-3 font-semibold text-white transition-colors hover:bg-green-600"
          >
            Mis pedidos
          </Link>
        </div>
      </div>
    </MainLayout>
  );
}
